import { InputAdornment } from "@mui/material";
import { ElementType, FC } from "react";
import { useTypedTranslation } from "../../../hooks";
import * as Styled from "./EditInvestmentStrategyPage.styled";

type EditInvestmentStrategyFundAllocationProps = {
    fundMaxPercentageAllocation: number;
    fundName: string;
    index: number;
};

export const EditInvestmentStrategyFundAllocation: FC<EditInvestmentStrategyFundAllocationProps> = ({
    fundMaxPercentageAllocation,
    fundName,
    index,
}) => {
    const { t } = useTypedTranslation();

    return (
        <Styled.CardPaper variant="outlined">
            <Styled.FundAllocationTextInput
                name={`funds.${index}.allocation`}
                type="text"
                InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                }}
                inputProps={{
                    maxLength: 3,
                }}
                label={
                    <>
                        <Styled.BoldBodyTextM component="p">{fundName}</Styled.BoldBodyTextM>
                        <Styled.NormalBodyTextM component="p">
                            {`${t("investmentStrategy.pensionQuestionnaire.editInvestmentStrategyPage.common.recommendedUpTo")} ${fundMaxPercentageAllocation} %`}
                        </Styled.NormalBodyTextM>
                    </>
                }
                LabelComponent={CustomLabelComponent}
                WrapperComponent={Styled.SpaceBetweenStack}
            />
        </Styled.CardPaper>
    );
};

const CustomLabelComponent: ElementType = (props) => (
    <Styled.InputLabelBox>
        <label htmlFor={`${props.name}-name`} {...props} />
    </Styled.InputLabelBox>
);
